import { render } from "./ConsultSection.vue?vue&type=template&id=5c9f24e3&scoped=true"
import script from "./ConsultSection.vue?vue&type=script&lang=js"
export * from "./ConsultSection.vue?vue&type=script&lang=js"

import "./ConsultSection.vue?vue&type=style&index=0&id=5c9f24e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c9f24e3"]])

export default __exports__